import BaseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import { getABParticipationStatus } from '../../app/functions';
import store from '../../redux';

class SearchBenefitsRequest extends BaseRequest {
  constructor(onResponse) {
    super();
    this.dispatch = null;
    this.response = null;
    this.name = 'Search Benefits Request';
    this.config = new AppConfig();
    this.onResponse = onResponse;
  }

  execute(dispatch, payload) {
    this.dispatch = dispatch;
    this.payload = payload;

    const { searchConfiguration } = store.getState().config.Parameters;
    const { abTestingPercentageForSearch, apiPath } = searchConfiguration;

    // We keep the original behavior for the users that not taking part in the AB testing of the new search-service
    if (getABParticipationStatus('searchABTestingIncluded', abTestingPercentageForSearch)) {
      this.useNewResponseFormat = true;
      this.call(this.payload.index || '', this.payload, 'get', {
        basePath: apiPath,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        stringifyData: true,
      });
    } else {
      this.call(this.config.api.requests.searchBenefits, this.payload);
    }
  }

  onSuccess() {
    this.onResponse(this.response.data);
  }
}

export default SearchBenefitsRequest;
